import {Component} from '@angular/core';

@Component({
  selector: 'pl-loading-bubbles',
  templateUrl: './loading-bubbles.component.html',
  styleUrls: ['./loading-bubbles.component.scss'],
  standalone: true
})
export class LoadingBubblesComponent {}
